{
  "header": "No Access",
  "subheader": "We're sorry. You don't have access to CoLab.",
  "cta": "Back to Axis",
  "homeLink": "https://axis.ehr.com"
}
